<template>
  <div v-if="helpText">
    <p class="font-weight-bold text-h6 pb-0 mb-0 ">
      {{ $i18n.t($router.currentRoute.meta.titleKey) }}
    </p>
    <p class="text-subtitle-1">
      {{ helpText }}
    </p>
    <v-divider class="pb-5" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'HelpHeader',
  props: { },
  data() {
    return {};
  },
  computed: {
    helpText(): string | null {
      const key = `help.settings.${this.$router.currentRoute.name}`;
      // console.log(key);
      return this.$i18n.tc(key) === key ? null : this.$i18n.tc(key);
    },
  },
});
</script>
